import {
  LeaderBoardSortDirectionEnum as CollectionSearchSortDirection,
  LeaderBoardSortFieldEnum,
} from "@rarible/marketplace-backend-v6-client/build"
import type { Blockchain } from "../../blockchain/types"
import type { Drop } from "../../drop/types"
import type { PriceValue } from "../../price/types"
import type { CollectionId } from "../types"
export { LeaderBoardPeriodEnum as CollectionStatisticPeriod } from "@rarible/marketplace-backend-v6-client/build"

interface CollectionSearchItemStatistic {
  floor?: {
    value?: PriceValue
    changePercent?: number
    chartData: number[]
  }
  volume?: {
    value: PriceValue
  }
  sales: number
  topOffer?: {
    value: PriceValue
  }
  owners: number
  listedItems: number
  items: number
}

export interface CollectionSearchItem {
  id: CollectionId
  name: string
  image?: string
  blockchain: Blockchain
  verified: boolean
  statistics: CollectionSearchItemStatistic
  drop?: Drop
}

export enum CollectionSearchSort {
  FLOOR = LeaderBoardSortFieldEnum.FLOOR,
  FLOOR_CHANGE = LeaderBoardSortFieldEnum.FLOOR_CHANGE,
  SALES = LeaderBoardSortFieldEnum.SALES,
  OWNERS = LeaderBoardSortFieldEnum.OWNERS,
  LISTED = LeaderBoardSortFieldEnum.LISTED,
  VOLUME = LeaderBoardSortFieldEnum.VOLUME,
  // Should be added to the API
  TOP_OFFER = "TOP_OFFER",
}

export { CollectionSearchSortDirection }
